import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { startLogout } from '../actions/auth';

//<Link onClick={e => (!name || !room) ? e.preventDefault() : null} to={`/chat?name=${name}&room=${room}`}>
//"/chat?name='Joe'&room='222'"
{/* <Link className="header__title" to={`/chat?name=${props.profile.displayName}&room=${props.profile.room}`}>
<h3>Chat</h3>
</Link> */}

export const Header = (props) => (
  <header className="header">
    <div className="content-container">
      <div className="header__content">
        <Link className="header__title" to="/dashboard">
          <h1>Expenses</h1>
        </Link>

        <div className="header-items">
          <button className="button button--link " onClick={props.startLogout}>Logout</button>
          <div className="header-img-container">
            {props.profile.photoURL ? <img className="header__img" src={props.profile.photoURL} /> : ""}
          </div>
        </div>
      </div>
    </div>

  </header>
);

// const mapStateToProps = (state) => ({

//   displayName: state.auth.displayName


// })

const mapStateToProps = (state) => ({

  profile: {
    displayName: state.auth.displayName,
    email: state.auth.email,
    photoURL: state.auth.photoURL,
    room: 'Expense Users'
  }



})



const mapDispatchToProps = (dispatch) => ({

  startLogout: () => dispatch(startLogout())
})



export default connect(mapStateToProps, mapDispatchToProps)(Header);



// WEBPACK FOOTER //
// ./src/components/Header.js